import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticClass:"text-xs-center"},[_c(VBtn,{attrs:{"large":"","color":"primary"},on:{"click":_vm.signInGoogle}},[_c('i',{staticClass:"fab fa-google fa-2x"}),_c('span',{staticClass:"pl-2"},[_vm._v("Sign in with Google")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }